import axios from 'axios'
import store from './index'
import * as auth from "@/utils/auth"
import ElementUI from 'element-ui';
import {resetMsg} from '@/js/resetMessage.js';
//import Vue from 'vue'
//let vue =new Vue();
//使用路由跳转
import router from '@/router/index'
var devflag = process.env.NODE_ENV;
var protocol = document.location.protocol;
var domain = window.location.host;
var root = (devflag === 'development')?process.env.API_ROOT: protocol+"//"+domain+"/"+process.env.API_ROOT;
var API_ROOT_PROJECT = (devflag === 'development')?process.env.API_ROOT_PROJECT:protocol+"//"+domain+"/"+process.env.API_ROOT_PROJECT;
var API_ROOT_CONTRACT = (devflag === 'development')?process.env.API_ROOT_CONTRACT:protocol+"//"+domain+"/"+process.env.API_ROOT_CONTRACT;
var API_ROOT_HR =(devflag === 'development')?process.env.API_ROOT_HR:protocol+"//"+domain+"/"+process.env.API_ROOT_HR;
var API_ROOT_SCM =(devflag === 'development')?process.env.API_ROOT_SCM: protocol+"//"+domain+"/"+process.env.API_ROOT_SCM;
var API_ROOT_FLOW =(devflag === 'development')?process.env.API_ROOT_FLOW: protocol+"//"+domain+"/"+process.env.API_ROOT_FLOW;
var API_ROOT_INTERFACE =(devflag === 'development')?process.env.API_ROOT_INTERFACE:protocol+"//"+domain+"/"+process.env.API_ROOT_INTERFACE;
var SYS_NAME = process.env.SYS_NAME;
var PROVINCECODE = 'PH';
let requestNum = 0;
// axios.defaults.timeout = 5000;
axios.interceptors.request.use(  
    config => {
		requestNum += 1;
		store.dispatch("hideLoading", true);
        return config;
    },
    err => {
        return Promise.reject(err);
    });

axios.interceptors.response.use(response => {
    let errormsg = "";
    requestNum -= 1;
	if(requestNum <=0) {
		store.dispatch("hideLoading", false);
	}
    //后端接口服务返回正常
    if(response.status == 200){
        //业务报错跳转
        if(response.data)
        {
            var browsertype = getBrowser();
            //IE模式下需装换类型
            if(browsertype == "IE"){
                response.data = JSON.parse(response.data);
            }
            console.log("response.data",response.data);
            //let responseData= response.data;
            let responseData= response.data;
            if(typeof responseData == "string"){
                    responseData = eval('(' + responseData + ')');
            }
            if(responseData.code === "-1"){
                requestNum = 0;
                errormsg = response.data.msg;
                router.push({path: '/error',name:'error',params: {msg: errormsg}});
                return Promise.reject(response);
            }else if(responseData.code === "-9"){
                requestNum = 0;
                //未登陆或者session过期的情况下直接跳转到登陆页
            //router.push({path: '/login',name:'login',params: {sysid: SYS_NAME}});
                errormsg = response.data.msg;
                router.push({path: '/error',name:'error',params: {msg: errormsg}});
                return Promise.reject(response);
            }else if(responseData.code === "500"){
                requestNum = 0;
                //未登陆或者session过期的情况下直接跳转到登陆页
            //router.push({path: '/login',name:'login',params: {sysid: SYS_NAME}});
                errormsg = response.data.msg;
                router.push({path: '/error',name:'error',params: {msg: errormsg}});
                return Promise.reject(response);
            }
            else if(responseData.code === "-2"){
                requestNum = 0;
                errormsg = responseData.msg;
                let sysDuration=3000;
                if(SYS_NAME=='HR'){
                    sysDuration=15000;
                }
                ElementUI.Message({ 
                    message: errormsg,
                    type: 'error',
                    duration:sysDuration
                });
                return Promise.reject(response);
            }else if(responseData.code === "9"){//未登录跳转页面
                requestNum = 0;
                router.push({path: "/portal/login",query: {}});
                return Promise.reject(response);
            } else{
                return response;
            }
        }
        else{//附件下载时只会返回文件流，特殊处理
            return response;
        }
        
    }

},
    err => {
        requestNum = 0;
        let errormsg = "";
        if (err && err.response) { 
            console.log("err.response.data"+err.response);  
            switch (err.response.status) {  
              case 400:     
               errormsg = 'Bad Request(400)' ; 
                break     
              case 401:    
                 errormsg = 'Unauthorized(401)' 
                break 
              case 403:   
                errormsg = 'Forbidden(403)'
                break    
              case 404:    
                errormsg = 'Not Found(404)'
                break 
              case 405:    
              errormsg = 'Method Not Allowed(405)'
                break 
              case 408:   
                errormsg = 'Request Time-out(408)' 
                break   
              case 500: {
                errormsg = err.response.data.msg;
                break 
              }           
              case 501:     
                errormsg = 'Not Implemented(501)'  
                break   
              case 502:     
                 errormsg = 'Bad Gateway(502)'  
                break     
              case 503:        
                errormsg = 'Service Unavailable(503)'    
                break     
              case 504:  
                errormsg = 'Gateway Time-out(504)'   
                break  
              case 505:      
                errormsg = 'HTTP Version not supported(505)'  
                break   
              default:  
                errormsg = 'Other Error'
           } 
        }  
        console.log(errormsg);
        if(errormsg==""&&err.code === 'ECONNABORTED' && err.message.indexOf('timeout') !== -1&&err.config.url.indexOf('/file/')!==-1){
            ElementUI.Message({ 
                message: "Internet Connection is slow, please wait",
                type: 'error'
            });
            store.dispatch("hideLoading", false);
            return; 
        }
        //跳转到错误页面
        //router.push({path: '/error',name:'error',params: {msg: errormsg}});
        if(errormsg==""){
            errormsg='Other Error';
        }
        if(errormsg.length>300){
        	errormsg=errormsg.substring(0,300);
        }
        resetMsg.error(errormsg+"...");
        store.dispatch("hideLoading", false);
        //return; 
        return Promise.reject(err);
    });

// 获取后端请求的url地址
function getHttpUrl(url, data)
{
    //判断是否传了自定义的链接地址
    let path = data.path;
    let sysid = data.sysid;
    if(sysid == undefined || sysid === null || sysid === ''){
        for(var i = 0 ; i < data.length ; i++){
            sysid = data[i].sysid;
            if(sysid != undefined || sysid != null || sysid != ''){
                break;
            }
        }
    }

    if(path == undefined || path === null || path === ''){
        if(sysid == 'CONTRACT'){
            url = API_ROOT_CONTRACT+url.replace(/api/, '');
        }else if(sysid == 'PROJECT'){
            url = API_ROOT_PROJECT+url.replace(/api/, '');
        }else if(sysid == 'SCM'){
            url = API_ROOT_SCM+url.replace(/api/, '');
        }else if(sysid == 'HR'){
            url = API_ROOT_HR+url.replace(/api/, '');
        }else if(sysid == 'INTERFACE'){
            url = API_ROOT_INTERFACE+url.replace(/api/, '');
        }else{
        	let flowsysid=data.flowsysid;
        	if(flowsysid == 'FLOW'){
                url = API_ROOT_FLOW+url.replace(/api/, '');
        	}else{
        		url = root+url.replace(/api/, '');
        	}
        }   
    }else{
        url = path+url.replace(/api/, '');
    }
    return url;
}

//自定义返回值类型
function posttype(url, data, restype)
{

    url = getHttpUrl(url, data);

    data = JSON.stringify(data);
    axios.defaults.withCredentials = true;
    // axios.defaults.baseURL = urlPre;
    axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
    // console.log('2019年09月25日11:03:30 http.js[进入axios post]——[data] :',data);
    // if (Object.prototype.toString.call(data) == '[object FormData]') {
    //     // 文件上传修改header
    //     console.log('2019年09月25日10:59:09 http.js[数据为FormData]——[data] :',data);
    //     axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
    // }

    //设置session的token
    var ffToken = auth.getToken(); //getCookie("ffToken");
    //设置语言包
    var ffLang = window.localStorage.getItem('localeLanguage');//this.getLanguageType();//getCookie("ffLang");//this.$i18n.locale;    //this.getLanguageType(); //getCookie("ffLang");
    axios.defaults.headers.post['ffToken'] = ffToken;
    axios.defaults.headers.post['ffLang'] = ffLang;
    axios.defaults.headers.post['Access-Control-Allow-Origin'] = 'http://localhost:9001';//'http://192.168.36.193:7001'; http://localhost:8080

    let config = {

        url: url,

        method: 'post', // default

        // baseURL: "",

        transformRequest: [function (data) {
            return data;
        }],
        withCredentials: true,
        transformResponse: [function (data) {
            return data;
        }],

        // 请求头信息
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Access-Control-Allow-Origin': '*'
            // 'Cookie': 'JSESSIONID=' + store.state.cookie,
        },

        //parameter参数
        params: {
            timestamp: Date.parse(new Date()) / 1000,

        },

        //post参数，使用axios.post(url,{},config);如果没有额外的也必须要用一个空对象，否则会报错
        data: data,
        proxy: {
            // host: 'http://192.168.13.19',
            // port: '7777',
            // auth: {
            //     username: 'fangyang',
            //     password: '1608@ffcs'
            // }
        },
        xsrfCookieName: 'auth_token',
        xsrfHeaderName: 'X-Auth-Token',
        //设置超时时间
        timeout: 2000000,
        //返回数据类型
        responseType: restype // 指定类型

    }
    return axios.post(url, data, config)

}
function posttype2(url, data, restype,callBackFunc)
{

    url = getHttpUrl(url, data);

    data = JSON.stringify(data);
    axios.defaults.withCredentials = true;
    // axios.defaults.baseURL = urlPre;
    axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
    // console.log('2019年09月25日11:03:30 http.js[进入axios post]——[data] :',data);
    // if (Object.prototype.toString.call(data) == '[object FormData]') {
    //     // 文件上传修改header
    //     console.log('2019年09月25日10:59:09 http.js[数据为FormData]——[data] :',data);
    //     axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
    // }

    //设置session的token
    var ffToken = auth.getToken(); //getCookie("ffToken");
    //设置语言包
    var ffLang = window.localStorage.getItem('localeLanguage');//this.getLanguageType();//getCookie("ffLang");//this.$i18n.locale;    //this.getLanguageType(); //getCookie("ffLang");
    axios.defaults.headers.post['ffToken'] = ffToken;
    axios.defaults.headers.post['ffLang'] = ffLang;
    axios.defaults.headers.post['Access-Control-Allow-Origin'] = 'http://localhost:9001';//'http://192.168.36.193:7001'; http://localhost:8080

    let config = {

        url: url,

        method: 'post', // default

        // baseURL: "",

        transformRequest: [function (data) {
            return data;
        }],
        withCredentials: true,
        transformResponse: [function (data) {
            return data;
        }],

        // 请求头信息
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Access-Control-Allow-Origin': '*'
            // 'Cookie': 'JSESSIONID=' + store.state.cookie,
        },

        //parameter参数
        params: {
            timestamp: Date.parse(new Date()) / 1000,

        },

        //post参数，使用axios.post(url,{},config);如果没有额外的也必须要用一个空对象，否则会报错
        data: data,
        proxy: {
            // host: 'http://192.168.13.19',
            // port: '7777',
            // auth: {
            //     username: 'fangyang',
            //     password: '1608@ffcs'
            // }
        },
        xsrfCookieName: 'auth_token',
        xsrfHeaderName: 'X-Auth-Token',
        //设置超时时间
        timeout: 2000000,
        //返回数据类型
        responseType: restype // 指定类型

    }
    if(callBackFunc instanceof Object){
        for(let key in callBackFunc){
            config[key] = callBackFunc[key]
        }
    }
    return axios.post(url, data, config)

}
function post(url, data) {
    url = getHttpUrl(url, data);
    let ispasstoken = data.t_params;
    console.log("url:"+url);
    data = JSON.stringify(data);
    axios.defaults.withCredentials = true;
    // axios.defaults.baseURL = urlPre;
    axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
    // console.log('2019年09月25日11:03:30 http.js[进入axios post]——[data] :',data);
    // if (Object.prototype.toString.call(data) == '[object FormData]') {
    //     // 文件上传修改header
    //     console.log('2019年09月25日10:59:09 http.js[数据为FormData]——[data] :',data);
    //     axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
    // }

    //设置session的token
    var ffToken = auth.getToken(); //getCookie("ffToken");
    console.log("ffToken",ffToken);
    //设置语言包
    var ffLang = window.localStorage.getItem('localeLanguage');//this.getLanguageType();//getCookie("ffLang");//this.$i18n.locale;    //this.getLanguageType(); //getCookie("ffLang");
    //var ffLang = getCookie("ZSMART_LOCALE"); 
    console.log("ffLang:"+ffLang);
    axios.defaults.headers.post['ffToken'] = ffToken;
    axios.defaults.headers.post['ffLang'] = ffLang;
    axios.defaults.headers.post['sysid'] = SYS_NAME;
    axios.defaults.headers.post['provincecode'] = PROVINCECODE;

    axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';//'http://192.168.36.193:7001'; http://localhost:8080
    let v_params = {
        timestamp: Date.parse(new Date()) / 1000,
    };

    if(ispasstoken == '1'){
        
        v_params.t_params = '1';
    }

    let config = {

        url: url,

        method: 'post', // default

        // baseURL: "",

        transformRequest: [function (data) {
            return data;
        }],
        withCredentials: true,
        transformResponse: [function (data) {
            return data;
        }],

        // 请求头信息
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods':'GET,POST',
            'Access-Control-Allow-Headers':'Authorization,Origin, X-Requested-With, Content-Type, Accept'
            // 'Cookie': 'JSESSIONID=' + store.state.cookie,
        },

        //parameter参数
        params: v_params,

        //post参数，使用axios.post(url,{},config);如果没有额外的也必须要用一个空对象，否则会报错
        data: data,
        proxy: {
            // host: 'http://192.168.13.19',
            // port: '7777',
            // auth: {
            //     username: 'fangyang',
            //     password: '1608@ffcs'
            // }
        },
        xsrfCookieName: 'auth_token',
        xsrfHeaderName: 'X-Auth-Token',
        //设置超时时间
        timeout: 500000,
        //返回数据类型
        responseType: 'json' // default

    }
    return axios.post(url, data, config)
}

function postUpload(url, data) {
    console.info("=============="+root);
    url = root+url.replace(/api/, '');

    // data = data = JSON.stringify(data);
    axios.defaults.withCredentials = true;
    // axios.defaults.baseURL = urlPre;
    axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
    // axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
    // console.log('2019年09月25日11:03:30 http.js[进入axios post]——[data] :',data);
    // if (Object.prototype.toString.call(data) == '[object FormData]') {
    //     // 文件上传修改header
    //     console.log('2019年09月25日10:59:09 http.js[数据为FormData]——[data] :',data);
    //     axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
    // }

    //设置session的token
    var ffToken = auth.getToken(); //getCookie("ffToken");
    console.log("===========ffToken:"+ffToken);
    //设置语言包
    var ffLang = window.localStorage.getItem('localeLanguage');//this.getLanguageType();//getCookie("ffLang");//this.$i18n.locale;    //this.getLanguageType(); //getCookie("ffLang");
    axios.defaults.headers.post['ffToken'] = ffToken;
    axios.defaults.headers.post['ffLang'] = ffLang;
    axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';//'http://192.168.36.193:7001'; http://localhost:8080

    let config = {

        url: root+url,

        method: 'post', // default

         baseURL: "",

        // transformRequest: [function (data) {
        //     return data;
        // }],
        withCredentials: true,
        // transformResponse: [function (data) {
        //     return data;
        // }],

        // // 请求头信息
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Access-Control-Allow-Origin': '*'
            // 'Cookie': 'JSESSIONID=' + store.state.cookie,
        },

        // parameter参数
        params: {
            timestamp: Date.parse(new Date()) / 1000,
        },

        //post参数，使用axios.post(url,{},config);如果没有额外的也必须要用一个空对象，否则会报错
        // data: data,//在上传附件中，如果给了就会报错
        // proxy: {
        //     // host: 'http://192.168.13.19',
        //     // port: '7777',
        //     // auth: {
        //     //     username: 'fangyang',
        //     //     password: '1608@ffcs'
        //     // }
        // },
        xsrfCookieName: 'auth_token',
        xsrfHeaderName: 'X-Auth-Token',
        //设置超时时间
         timeout: 500000,
        // //返回数据类型
        // responseType: 'json' // 返回如果是String就会无法显示

    }
    return axios.post(url, data, config)
}
function postUpload2(url, data,callBackFunc) {
  
    url = root+url.replace(/api/, '');

    axios.defaults.withCredentials = true;
    // axios.defaults.baseURL = urlPre;
    axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';

    //设置session的token
    var ffToken = auth.getToken(); //getCookie("ffToken");
    console.log("===========ffToken:"+ffToken);
    //设置语言包
    var ffLang = window.localStorage.getItem('localeLanguage');//this.getLanguageType();//getCookie("ffLang");//this.$i18n.locale;    //this.getLanguageType(); //getCookie("ffLang");
    axios.defaults.headers.post['ffToken'] = ffToken;
    axios.defaults.headers.post['ffLang'] = ffLang;
    axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';//'http://192.168.36.193:7001'; http://localhost:8080

    let config = {
        url: root+url,

        method: 'post', // default

         baseURL: "",

        // transformRequest: [function (data) {
        //     return data;
        // }],
        withCredentials: true,
        // transformResponse: [function (data) {
        //     return data;
        // }],

        // // 请求头信息
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Access-Control-Allow-Origin': '*'
            // 'Cookie': 'JSESSIONID=' + store.state.cookie,
        },

        // parameter参数
        params: {
            timestamp: Date.parse(new Date()) / 1000,
        },
        
        xsrfCookieName: 'auth_token',
        xsrfHeaderName: 'X-Auth-Token',
        //设置超时时间
        timeout: 500000,
        // //返回数据类型
        // responseType: 'json' // 返回如果是String就会无法显示

    }
    if(callBackFunc instanceof Object){
        for(let key in callBackFunc){
            config[key] = callBackFunc[key]
        }
    }
    return axios.post(url, data, config)
}

function get(url) {
    url = url.replace(/api/, '');
    url = store.state.urlHead + url + '&JSESSIONID=' + store.state.cookie;
    let config = {

        url: url,

        method: 'get', // default

        // baseURL: store.state.urlHead,
        baseURL: store.state.urlHead,

        // 请求头信息
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Access-Control-Allow-Origin': '*',
        },

        //parameter参数
        params: {
            timestamp: Date.parse(new Date()) / 1000
        },

        //post参数，使用axios.post(url,{},config);如果没有额外的也必须要用一个空对象，否则会报错

        proxy: {
            // host: 'http://192.168.13.19',
            // port: 7777,
            // auth: {
            //     username: 'fangyang',
            //     password: '1608@ffcs'
            // }
        },
        //设置超时时间
        timeout: 5000,
        //返回数据类型
        responseType: 'json' // default

    }
    return axios.get(url, this.config)
}

//设置cookies信息
function Setcookie(c_name, c_value) {
    // 设置名称为name,值为value的Cookie
    var expdate = new Date(); // 初始化时间
    expdate.setTime(expdate.getTime() + 4 * 60 * 60 * 1000); // 时间
    document.cookie = c_name + "=" + c_value + ";expires=" + expdate.toGMTString() + ";path=/";
    // 时间可以不要，但路径(path)必须要填写，因为JS的默认路径是当前页，如果不填，此cookie只在当前页面生效！~
}

//读取cookies信息
function getCookie(c_name) {
    if (document.cookie.length > 0) {
        var c_start = document.cookie.indexOf(c_name + "=");
        if (c_start != -1) {
            c_start = c_start + c_name.length + 1;
            var c_end = document.cookie.indexOf(";", c_start);
            if (c_end == -1) {
                c_end = document.cookie.length;
            }
            return unescape(document.cookie.substring(c_start, c_end));
        }
    }
    return "";
}

//删除cookies
function delCookie(name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 60 * 1000);
    var cval = getCookie(name);
    if (cval != null)
        document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString() + ";path=/";
}
/**
 *  判断浏览器类型
 */
function getBrowser(){
    var userAgent =window.navigator.userAgent; //取得浏览器的userAgent字符串
    var isOpera = userAgent.indexOf("Opera") > -1;
    if (isOpera) {
        return "Opera"
    } //判断是否Opera浏览器
    if (userAgent.indexOf("Firefox") > -1) {
        return "FF";
    } //判断是否Firefox浏览器
    if (userAgent.indexOf("Chrome") > -1){
    return "Chrome";
    }
    if (userAgent.indexOf("Safari") > -1) {
        return "Safari";
    } //判断是否Safari浏览器
    if (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1 && !isOpera) {
        return "IE";
    }else if(userAgent.indexOf("Trident") > -1){
        return "IE";
    } //判断是否IE浏览器
}

export {
    post,
    get,
    postUpload,
    postUpload2,
    posttype,
    posttype2,
    Setcookie,
    getCookie
}


// WEBPACK FOOTER //
// ./src/store/http.js